<template>
  <div>
    <a-card :bordered="false" style="margin-bottom: 24px">
      <a-row :gutter="[24, 0]">
        <a-form-model class="ant-advanced-search-form">
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="输入搜索：">
              <a-input-search
                v-model="query.goodsName"
                placeholder="请输入商品名称"
                style="width: 100%"
                @search="initData"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="分类：">
              <h-cascader
                v-model="field"
                :options="mainFieldsOptions"
                :fieldNames="{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }"
                change-on-select
                allowClear
                placeholder="全部分类"
                style="width: 100%"
                @change="initData"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="状态：">
              <h-select v-model="query.status" allowClear placeholder="全部状态" @change="() => initData()">
                <a-select-option
                  v-for="statusInfo in statusOptions"
                  :key="statusInfo.value"
                  :value="statusInfo.value"
                  >{{ statusInfo.label }}</a-select-option
                >
              </h-select>
            </a-form-model-item>
          </a-col>
        </a-form-model>
      </a-row>
    </a-card>
    <a-card :body-style="{ padding: 0 }">
      <div slot="title">
        <span>商品列表</span>
      </div>
      <div slot="extra">
        <a-button
          v-if="$auth('goods_skill_add')"
          type="primary"
          shape="round"
          @click="$router.push('/goods/skill/create')"
        >
          <a-icon type="plus" />新增
        </a-button>
      </div>
      <main-table ref="table" v-if="$auth('goods_skill_list')"></main-table>
    </a-card>
  </div>
</template>

<script>
import MainTable from './components/MainTable'
import { GOODS_SKILL_STATUS } from '@/store/dictionary'
import * as commonAPi from '@/api/common'
export default {
  name: 'GoodsManagementSkillList',
  components: {
    MainTable,
  },
  data() {
    return {
      query: {
        parentClassification: undefined,
        classification: undefined,
        goodsName: undefined,
        status: undefined,
      },
      mainFieldsOptions: [],
      field: [],
      statusOptions: GOODS_SKILL_STATUS,
    }
  },
  activated() {
    if (this.ready) {
      this.initData()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.ready = true
    })
    commonAPi.fieldsOptions().then((res) => {
      this.mainFieldsOptions = res.data.filter((v) => v.level === 'MAIN')
    })
    this.initData()
  },
  methods: {
    initData() {
      const { query, field } = this
      query.parentClassification = field[0]
      query.classification = field[1]
      this.$refs.table.initData(query)
    },
  },
}
</script>

<style lang="less" scoped>
.ant-advanced-search-form /deep/ .ant-form-item {
  display: flex;
  margin-bottom: 0;
}
.ant-advanced-search-form /deep/ .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
